import React from "react";

const SearchInput = ({ placeholder = "Buscar", onChange, value }) => {
  return (
    <div className="flex items-center justify-start border h-[40px] w-[322px] border-[#76A140] rounded-md">
      <div className="px-2">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1669_6178)">
            <path
              d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
              fill="#76A140"
            />
          </g>
          <defs>
            <clipPath id="clip0_1669_6178">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        className="py-2 w-full rounded-tr-md font-itcmedium rounded-br-md focus:outline-none placeholder-[#76A140] text-[#76A140] placeholder:font-itcmedium text-[15px]"
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;
